/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import { FormControl, OutlinedInput, Box } from '@mui/material';

import { calcRem } from 'utils';

const AlertForm = ({ formContext }) =>
  formContext.alert_form_fields.map(field => (
    <Box key={field.label} marginBottom="1rem">
      <FormControl fullWidth>
        <OutlinedInput
          sx={{ borderRadius: 0, height: calcRem(35) }}
          placeholder={field.label}
          name={field.label}
          aria-describedby={field.label}
          inputProps={{ style: { height: '.5rem' } }}
        />
      </FormControl>
    </Box>
  ));

AlertForm.propTypes = {
  formContext: PropTypes.shape({
    alert_form_fields: PropTypes.shape({
      label: PropTypes.string
    })
  }).isRequired
};

export default AlertForm;
